import React, { useState } from 'react';
import { FaTrash, FaGlobe, FaPenToSquare } from 'react-icons/fa6';
import { useAppContext } from '../../../../shared/context/AppContext';
import { getUserId } from '../../../../shared/domain/services/userService';
import * as deleteContextVariableController from '../controllers/deleteContextVariableController';
import './ContextVariableCard.css';

const ContextVariableCard = ({ contextVariable, onUpdate, onDelete, onEdit }) => {
  const { user } = useAppContext();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const userId = getUserId(user);
  const isOwnVariable = userId && contextVariable.userId === userId;

  const handleCardClick = () => {
    if (isOwnVariable) {
      setIsExpanded(!isExpanded);
    }
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    if (onEdit) {
      onEdit(contextVariable);
    }
  };

  const handleDelete = async (e) => {
    e.stopPropagation();
    
    if (!window.confirm('Are you sure you want to delete this context variable?')) {
      return;
    }

    setIsDeleting(true);
    try {
      await deleteContextVariableController.deleteContextVariable(contextVariable.id);
      if (onDelete) {
        onDelete(contextVariable.id);
      }
    } catch (error) {
      console.error('Error deleting context variable:', error);
      alert('Failed to delete context variable. Please try again.');
      setIsDeleting(false);
    }
  };

  // Truncate context for preview
  const previewContext = contextVariable.context && contextVariable.context.length > 150
    ? contextVariable.context.substring(0, 150) + '...'
    : (contextVariable.context || '');

  return (
    <div className={`context-variable-card-wrapper ${isExpanded ? 'expanded' : ''}`}>
      <div 
        className={`context-variable-card ${isOwnVariable ? 'clickable' : ''} ${isExpanded ? 'expanded' : ''} ${contextVariable.isGlobal ? 'has-global-badge' : ''}`}
        onClick={handleCardClick}
      >
        {contextVariable.isGlobal && (
          <div className="global-badge">
            <FaGlobe className="global-icon" />
            <span>Global</span>
          </div>
        )}

        <div className="context-variable-card-content">
          <h3 className="context-variable-title">{contextVariable.title || 'Untitled'}</h3>
          
          <div className="context-variable-preview">
            {isExpanded && isOwnVariable ? (
              <div className="context-variable-full">
                <p>{contextVariable.context || ''}</p>
              </div>
            ) : (
              <p>{previewContext}</p>
            )}
          </div>

          {isOwnVariable && (
            <div className="context-variable-actions">
              <button
                className="edit-button"
                onClick={handleEdit}
                aria-label="Edit context variable"
              >
                <FaPenToSquare className="edit-icon" />
              </button>
              <button
                className="delete-button"
                onClick={handleDelete}
                disabled={isDeleting}
                aria-label="Delete context variable"
              >
                <FaTrash className="delete-icon" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContextVariableCard;

